<template>
  <c-sidesheet
    id="description-view-modal"
    :title="title || 'Просмотр описания'"
    :active="active"
    :hide-footer="!canEdit"
    @close="close"
  >
    <div class="description-view">
      <div v-if="description" class="text" v-html="description"></div>
      <div v-if="link" class="link">
        <div class="link__wrapper">
          <a :href="link" target="_blank">{{ link }}</a>
          <button class="link__copy" @click="copy">
            <svg-icon name="copy" :size="16"></svg-icon>
          </button>
        </div>

        <div v-if="copied" class="link__copied">
          <svg-icon name="check" color="success" />
          Ссылка скопирована
        </div>
      </div>
      <div class="files">
        <div v-if="docs.length" class="docs">
          <files :files="docs" :actions="true" />
        </div>
        <div v-if="images.length" class="images">
          <files :files="images" actions="preview" :show-video="true" :full-width="true" />
        </div>
      </div>
    </div>

    <template #actions>
      <c-button class="description-view__close" label="Закрыть" size="large" @click="close" />
      <c-button label="Редактировать" color="primary" size="large" @click="edit" />
    </template>
  </c-sidesheet>
</template>

<script>
import CButton from "@/components/controls2/Button";
import CSidesheet from "@/components/scrollable-sidesheet";
import Files from "@/components/files.vue";
import SvgIcon from "@/components/svg-icon";
import { getFileType } from "@/utils/files";
import { copyToClipboard } from "@/utils/browser/copy-to-clipboard";

export default {
  name: "violation-types-create-modal",
  components: {
    CButton,
    CSidesheet,
    Files,
    SvgIcon,
  },
  props: ["canEdit", "title"],
  data() {
    return {
      editableId: null,

      description: "",
      link: "",
      files: [],

      active: false,
      copied: false,
    };
  },
  computed: {
    typedFiles() {
      return this.files.map((file) => {
        const { name, url, id } = file;
        const type = getFileType(url);
        return {
          id,
          url,
          name,
          type,
        };
      });
    },
    docs() {
      return this.typedFiles.filter((file) => file.type !== "image" && file.type !== "video");
    },
    images() {
      return this.typedFiles.filter((file) => file.type === "image" || file.type === "video");
    },
  },
  watch: {
    copied(v) {
      if (v) {
        setTimeout(() => {
          this.copied = false;
        }, 3 * 1000);
      }
    },
  },

  methods: {
    open(data) {
      if (data) {
        this.setData(data);
      }
      this.active = true;
    },

    setData(data) {
      if (data) {
        const { editableId, description, link, files } = data;
        this.editableId = editableId;
        this.description = description;
        this.link = link;
        this.files = files;
      }
    },

    close() {
      this.active = false;
      this.reset();
      this.$nextTick(() => {
        setTimeout(() => {
          this.$emit("close");
        }, 300);
      });
    },

    reset() {
      this.editableId = null;
      this.description = "";
      this.link = "";
      this.files = [];
    },

    edit() {
      this.$emit("edit", this.editableId);
      this.close();
    },

    copy() {
      copyToClipboard(this.link).then(() => {
        this.copied = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars.scss";
@import "~@/assets/styles/grid.scss";

/deep/ {
  .scroll-container {
    max-width: calc(100% - 5px);
  }
  .shadow-bottom {
    display: none;
  }
  .modal-frame {
    &__header {
      margin-bottom: 18px;
    }
  }
}

.description-view {
  .text,
  .link,
  .images,
  .docs {
    margin-bottom: 24px;
  }

  .text {
    font-size: 13px;
  }

  .link {
    font-size: 15px;
    &__wrapper {
      display: flex;
      align-items: center;
    }
    &__copied {
      color: $color-success;
      margin-top: 12px;
      display: flex;
      align-items: center;

      /deep/ {
        .svg-icon {
          margin-right: 12px;
        }
      }
    }
    &__copy {
      background: none;
      padding: 0;
      cursor: pointer;
      margin-left: 12px;

      &,
      &:focus,
      &:hover {
        border: none;
        outline: none;
      }
    }
  }
}

@include onlyStandartMobile {
  /deep/ {
    .modal-actions {
      border-top: none !important;
    }
  }
}

@include bootstrapMd {
  .description-view {
    &__close {
      display: none;
    }
    .text {
      font-size: 15px;
    }
  }
}
</style>
